import { render, staticRenderFns } from "./SalePageFor480.vue?vue&type=template&id=ac85f894&scoped=true"
import script from "./SalePageFor480.vue?vue&type=script&lang=js"
export * from "./SalePageFor480.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac85f894",
  null
  
)

export default component.exports